import React from 'react'
import { Container } from "reactstrap";

const NotFound = _ => (
    <Container>
        <h1 style={styles.heading}>404 Not Found</h1>
    </Container>
);

export default NotFound;

const styles = {
    heading: {
        fontSize: 53,
        fontFamily: "Roboto Slab, sans-serif",
        fontWeight: 700,
        color: "#3c4858",
        marginTop: 50
    }
};


// WEBPACK FOOTER //
// ./src/Components/notFound.jsx